import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  IconButton,
  Tab,
  Tabs as MUITabs,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';
import { truncateString } from 'utils/helpers';

import { useFormContext, useWatch } from "react-hook-form";
import { ProrationsForm } from '../types';
import { defaultTabs } from '../utils';

type TabsProps = {
  selectedTabIndex: number,
  onSelectTab: (number) => void,
  onDelete: (prorationId: string) => void,
  disabledDelete: boolean
};

const useStyles = makeStyles((theme: any) => ({
  labelContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 'auto',
    gap: theme.spacing(1),
  },
  tab: {
    minWidth: theme.spacing(10),
    minHeight: theme.spacing(5),
    height: theme.spacing(5),
    padding: theme.spacing(0.5, 1),
    textTransform: 'capitalize',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    textAlign: 'left',
    '&.MuiTab-root': {
      minHeight: theme.spacing(5),
      height: theme.spacing(5),
      padding: theme.spacing(0.5, 1),
    },
    '& .MuiTab-wrapper': {
      width: '100%',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    [theme.breakpoints.down('md')]: {
      minWidth: theme.spacing(9),
      height: theme.spacing(5),
      padding: theme.spacing(0, 0.75),
      '&.MuiTab-root': {
        height: theme.spacing(5),
        padding: theme.spacing(0, 0.75),
      },
    },
  },
  tabs: {
    minHeight: theme.spacing(5),
    height: theme.spacing(5),
    '&.MuiTabs-root': {
      minHeight: theme.spacing(5),
      height: theme.spacing(5),
    },
    '& .MuiTabScrollButton-root': {
      width: theme.spacing(4),
      flexShrink: 0,
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(3.5),
      },
    },
  },
  selectedLabel: { color: theme.palette.primary.darker },
  closeButtonContainer: {
    display: 'flex',
    flexShrink: 0,
  },
  closeButton: {
    fontSize: 14,
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.primary.main,
  },
}));

export const Tabs = ({
  selectedTabIndex,
  onSelectTab,
  onDelete,
  disabledDelete
}: TabsProps) => {
  const classes = useStyles();

  const { control } = useFormContext<ProrationsForm>();
  const prorationsForm = useWatch({ control });
  return (
    <MUITabs
      className={classes.tabs}
      variant="scrollable"
      scrollButtons
      value={selectedTabIndex}
      onChange={(_, newIndex) => onSelectTab(newIndex)}
    >
      {prorationsForm.forms && prorationsForm.forms.map((value, index) => {
        return (
          <Tab
            key={value._id}
            className={clsx(classes.tab, { [classes.selectedLabel]: selectedTabIndex === index })}
            value={index}
            label={defaultTabs.includes(value.description!)
              ? truncateString(value.description!, 20)
              : (
                <Box className={classes.labelContainer}>
                  <Box>{truncateString(value.description!, 20)}</Box>

                  <Box className={classes.closeButtonContainer}>
                    <span>
                      <IconButton
                        component="div"
                        className={classes.closeButton}
                        onClick={() => onDelete(value._id!)}
                        disabled={disabledDelete}
                        size="large"
                      >
                        <FontAwesomeIcon icon="times" />
                      </IconButton>
                    </span>
                  </Box>
                </Box>
              )}
          />
        );
      })}
    </MUITabs>
  );
};
